<template>
  <div class="right-view">
    <div class="grid-box-view">
      <div class="main-grid-view">
        <div class="post-top-section">
          <div class="image-view-header">
            <div class="imagesection">
              <img :src="profileImage || defaultDP" alt="User profile" />
            </div>

            <div class="usersInfo">
              <span class="username">{{ username }}</span>
              <span
                ><img src="../icons/Verified.svg" class="verified-icon" alt="Verified badge"
              /></span>
              <!-- <span class="time">0h0min</span> -->
            </div>
          </div>
          <div class="share-icon">
            <img src="../icons/Actions.svg" alt="More actions" />
          </div>
          <div></div>
        </div>
   <div class="preview-section">
  <img v-if="formData.preview" :src="formData.preview" class="preview-img" alt="Post preview image" />
</div>


        <div class="bottom-grid">
          <span class="title-grid">{{
            truncateWords(formData.title, 4) || "Title"
          }}</span>
          <span class="desc-grid">{{
            truncateWords(formData.description, 4) || "Description"
          }}</span>
        </div>
      </div>

      <div class="location-view">
        <div class="location-info">
          <!-- existing location -->
          <div class="location">
            <img src="../icons/Frame 38.svg" alt="Location icon" />
            <span class="location-Text">
              {{ formData.location || "Location" }}</span
            >
          </div>

          <!-- new contact below -->
          <div class="contact">
            <img src="../icons/Frame 38 (1).svg" alt="Contact icon" />
            <span class="contact-Text">{{
              formData.phoneNumber
                ? `${formData.countryCode || "+1"} ${formData.phoneNumber}`
                : "Contact"
            }}</span>
          </div>
        </div>

        <div class="button-service">
          <button class="button-base">
            {{ formData.serviceType1 || "Service" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import defaultDP from "../icons/Avatar.svg";
import userDetailsServices from "../../services/userDetailsService";
import { ref, onMounted } from "vue";
const username = ref("username");
const profileImage = ref(defaultDP);
defineProps({
  formData: {
    type: Object,
    required: true,
  },
});
onMounted(() => {
  const userId = localStorage.getItem("userid");
  userDetailsServices
    .getUserInfo(userId)
    .then((response) => {
      username.value = response.data[0]?.userName || "username";
    })
    .catch(() => {
      username.value = "username";
    });
  userDetailsServices.getProfileImage(userId).then((imgUrl) => {
    profileImage.value = imgUrl || defaultDP;
  });
});
const truncateWords = (text, limit) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
};
</script>
<style scoped>
.grid-box-view {
  /* _Pricing tier card */

  box-sizing: border-box;

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;

  width: 400px;
  min-width: 320px;
  max-width: 400px;
  height: 348.31px;

  /* White */
  background: #ffffff;
  /* Gray/200 */
  border: 1px solid #e9eaeb;
  /* Shadow/lg */
  box-shadow: 0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03);
  border-radius: 16px;
}
.main-grid-view {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  /* gap: 16px; */
  background-size: contain;
  background-position: center;
  /* background-repeat: no-repeat;   */
  border-radius: 16px 16px 0 0;
  width: 400px;
  height: 280px;
  overflow: hidden;
}
.post-top-section {
  /* Reel / User (Feed) */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 16px;

  margin: 0 auto;
  width: 368px;
  height: 34px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin-bottom: 05px;
}
.image-view-header {
  /* User Info */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  width: 318px;
  height: 34px;
}
.share-icon {
  /* Actions */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px;
  gap: 8px;

  width: 24px;
  height: 24px;

  background: #ffffff;
  border-radius: 128px;

  /* Inside auto layout */
  flex: none;
  order: 2;
  flex-grow: 0;
}

.imagesection {
  width: 34px;
  height: 34px;
}
.imagesection img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}

.usersInfo {
  display: flex;
  flex-direction: row;
  align-items: center; /* ✅ vertically centers all inline elements */
  justify-content: flex-start;
  gap: 4px; /* subtle spacing between name, icon, and time */
  padding: 0;
  height: auto;
}

.username {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 1; /* ✅ keeps text tightly aligned with icon */
  letter-spacing: 0.01em;
  color: #000000;
  padding: 5px;
}

.verified-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  object-fit: contain;
  margin-bottom: 4px;
}

.time {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1;
  color: #000000;
  opacity: 0.9; /* optional subtle visual balance */
}

.bottom-grid {
  /* Heading and supporting text */

  /* Auto layout */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
gap:4px;

  margin: 0 auto;
  width: 368px;
  /* height: 58px; */

  /* Inside auto layout */
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}
.title-grid {
  /* Heading */

  width: 368px;
  height: 20px;

  /* Text xl/Semibold */
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  /* identical to box height, or 150% */

  /* Gray/900 */
  color: #181d27;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}
.desc-grid {
  /* Supporting text */

  width: 368px;
  height: 24px;

  /* Text md/Regular */
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* Gray/600 */
  color: #535862;

  /* Inside auto layout */
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.location-Text {
  width: 59px;
  height: 17px;

  font-family: "Inter";
  font-style: normal;
}

.location-view {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px 16px;
  gap: 16px;
  border-top: 1px solid #e9eaeb;
  width: 400px;
  height: auto;
}

.location-info {
  width:50%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
}
.location,
.contact {
  display: flex;
  align-items: center;
  gap: 8px;
  width: auto;
  height: auto;
  padding: 0;
}

.location-Text,
.contact-Text {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #535862;
  margin-top: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:180px;
}

.button-service {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(90deg, #e33629, #017dca) border-box;
  padding: 2px;
}

.button-base {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  padding: 3.5px 10.77px;
  margin: 0;
  border-radius: 4px;
  border: none;
  outline: none;
  cursor: pointer;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(90deg, #e33629, #017dca);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.preview-section {
  width: 370px;
  height: 150px;
  border-radius: 8px;
  background: #ffffff; /* fallback color */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-section img {
   width: 100%;
  height: 100%;
  object-fit: cover;
}
/* Default styles for desktop (>1200px) can remain as is */

/* Responsive for 700px – 1200px */
@media (min-width: 700px) and (max-width: 1200px) {
  .right-view {
    width: 50%;          /* take 50% of the container */
    max-width: 50%;
    display: flex;       /* ensure visible */
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .grid-box-view {
    width: 80%;         /* full width inside right view */
    max-width: 100%;
  }

  .main-grid-view {
    width: 100%;         /* adjust width */
    max-width: 100%;
  }

  .location-view {
    width: 100%;         /* take full width */
    flex-direction: row;
    justify-content: space-between;
  }


.location-Text{
  width:160px;
}
  .location-info {
    width: 48%;           /* slightly smaller to fit button-service */
  }

  .button-service {
    width: auto;          /* allow button to size itself */
  }

  .preview-section {
    width: 100%;          /* responsive preview image */
    height: 150px;
  }

  .bottom-grid {
    width: 100%;          /* fit text inside container */
  }

  .title-grid, .desc-grid {
    width: 100%;
  }
  .post-top-section{
    width:100%;
  }
}

/* Optional: below 700px make it stacked */
@media (max-width: 699px) {
  .right-view {
    width: 100%;         /* stacked below left view */
    max-width: 100%;
    margin-top: 20px;
  }

  .grid-box-view,
  .main-grid-view,
  .location-view,
  .preview-section,
  .bottom-grid,
  .title-grid,
  .desc-grid {
    width: 100%;
  }

  .location-info {
    width: 100%;
    margin-bottom: 8px;
  }
}

</style>
